<template>
  <div>
    <b-card>
      <b-row>
        <b-col
          cols="12"
          md="6"
        >
          <product-categories-category-select />
        </b-col>
        <b-col
          cols="12"
          md="6"
        >
          <products-brand-select />
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <products-title />
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <products-summary />
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <products-content />
        </b-col>
        <b-col
          cols="12"
          md="12"
        >
          <products-ordering />
        </b-col>
      </b-row>
    </b-card>
    <b-row>
      <b-col
        cols="12"
        md="12"
      >
        <products-image />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BRow, BCol, BCard,
} from 'bootstrap-vue'
import ProductsTitle from '@/views/Admin/Products/Elements/Form/Title.vue'
import ProductCategoriesCategorySelect from '@/views/Admin/Products/Elements/Form/CategorySelect.vue'
import ProductsSummary from '@/views/Admin/Products/Elements/Form/Summary.vue'
import ProductsContent from '@/views/Admin/Products/Elements/Form/Content.vue'
import ProductsOrdering from '@/views/Admin/Products/Elements/Form/Ordering.vue'
import ProductsImage from '@/views/Admin/Products/Elements/Form/ImageCard.vue'
import ProductsBrandSelect from '@/views/Admin/Products/Elements/Form/BrandSelect.vue'

export default {
  name: 'ProductFormCard',
  components: {
    ProductsBrandSelect,
    ProductsImage,
    ProductsOrdering,
    ProductsContent,
    ProductsSummary,
    ProductCategoriesCategorySelect,
    ProductsTitle,
    BRow,
    BCol,
    BCard,
  },
  computed: {
    itemData() {
      return this.$store.getters['products/dataItem']
    },
  },
}
</script>
